import { schema } from 'normalizr';

export default new schema.Entity('facilities', {
  facility_levels: [new schema.Entity('facility_levels')],
});
